import { defineComponent as _defineComponent } from 'vue'
import GoToService from '@/router/GoToService';
import {computed} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseNavigationLogo',
  props: {
    isMiniMenu: { type: Boolean },
    hover: { type: Boolean },
    readonly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isMiniMenu: boolean;
  hover: boolean;
  readonly: boolean;
}



const isSmallLogo = computed<boolean>(() => {
  return props.isMiniMenu && !props.hover;
});

const onLogoClick = () => {
  if (!props.readonly) {
    GoToService.dashboard();
  }
};

return { __sfc: true,props, isSmallLogo, onLogoClick }
}

})